"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHexFromAlphaPercentage = exports.getAlphaPercentageFromHex = void 0;
const getAlphaPercentageFromHex = (color) => {
    checkHexColor(color);
    const alphaHex = getAlphaHexValue(color);
    const hexValue = parseInt(alphaHex, 16);
    const percentage = Math.round((hexValue / 255) * 100);
    return percentage;
};
exports.getAlphaPercentageFromHex = getAlphaPercentageFromHex;
const getHexFromAlphaPercentage = (percentage) => {
    if (percentage < 0 || percentage > 100 || !Number.isInteger(percentage)) {
        throw new Error("Input must be an integer between 0 and 100.");
    }
    const decimalValue = Math.round((percentage / 100) * 255);
    const hexValue = decimalValue.toString(16).toUpperCase();
    return hexValue;
};
exports.getHexFromAlphaPercentage = getHexFromAlphaPercentage;
const checkHexColor = (color) => {
    // Check is it Hex type (String must start with '#')
    if (!color.startsWith("#")) {
        throw new Error("String must start with '#'.");
    }
    // hex6 or hex8 이어야 하기 때문에 length가 6보다 작거나 8보다 크면 안된다
    const lengthAfterHash = color.length - 1; // Excluding the '#'
    if (lengthAfterHash < 6 || lengthAfterHash > 8) {
        throw new Error("String must contain 6 to 8 characters after '#'.");
    }
};
const getAlphaHexValue = (color) => {
    // If the total length is 9 (1 for '#' and 8 additional characters)
    if (color.length === 9) {
        // Extract and return the last two characters
        return color.slice(-2);
    }
    else {
        // If there are not exactly 8 characters after '#', raise an error
        return "00";
    }
};
